import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonLoading } from '@ionic/vue'

interface Props {
    isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicLoading',
  props: {
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    isLoading: boolean;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonLoading), {
    "is-open": props.isLoading,
    message: "Loading...",
    spinner: "dots",
    mode: "ios"
  }, null, 8, ["is-open"]))
}
}

})